import {gql} from 'apollo-angular';

export const GET_ROOKIE_OFFER_TIME_SLOT_MAPPING_BY_CODE = gql`
  query GetRookieOfferTimeSlotMappingByCode($districtId: Int!, $shortCode: String!) {
    rookieOfferTimeSlotMappingByCode(districtId: $districtId, shortCode: $shortCode) {
      id
    }
  }
`;
